module.exports = __webpack_public_path__ + "static/img/college.de2e3d4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/college.jpg
// module id = psUo
// module chunks = 7